import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'

export const commonStyle = {
    fontFamily: fonts.primary,
    fontWeight: '400',
    color: 'black',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1)]
}

export const contentStyle = {
    paddingTop: [pxToRem(38), pxToRem(38), pxToRem(40), pxToRem(40)],
    paddingBottom: [pxToRem(40), pxToRem(40), pxToRem(40), pxToRem(40)],
    paddingLeft: [pxToRem(11), pxToRem(11), pxToRem(11), pxToRem(30)],
    paddingRight: [pxToRem(11), pxToRem(11), pxToRem(11), pxToRem(0)],
    backgroundColor: 'white',
    borderRadius: 0,
    width: pxToRem(921)
}

export const headerStyle = {
    paddingTop: [pxToRem(0)],
    paddingBottom: [pxToRem(20)],
    paddingLeft: [pxToRem(0)],
    paddingRight: [pxToRem(0)]
}

export const closeButton = {
    color: 'black',
    position: 'absolute',
    top: [pxToRem(13), pxToRem(13), pxToRem(13), pxToRem(20)],
    right: [pxToRem(11), pxToRem(11), pxToRem(11), pxToRem(20)],
    height: pxToRem(15),
    minWidth: pxToRem(15)
}

export const headerTextStyle = {
    color: 'black',
    marginBottom: [pxToRem(0), pxToRem(0), pxToRem(10), pxToRem(10)],
    fontFamily: fonts.primary,
    fontSize: [pxToRem(16), pxToRem(16), pxToRem(18), pxToRem(18)],
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(2), pxToRem(2), pxToRem(3), pxToRem(3)],
    textTransform: 'uppercase'
}

export const bodyStyle = {
    padding: [pxToRem(0)]
}

export const productDetailsSection = {
    width: ['100%', '100%', '100%', '58%'],
    borderRightWidth: [pxToRem(0), pxToRem(0), pxToRem(0), pxToRem(1)],
    borderBottomWidth: [pxToRem(1), pxToRem(1), pxToRem(1), pxToRem(0)],
    borderRightColor: 'cav_light_input_gray',
    borderBottomColor: 'cav_light_input_gray',
    paddingTop: pxToRem(10),
    paddingBottom: [pxToRem(30), pxToRem(30), pxToRem(30), pxToRem(10)]
}

export const productDetailsInnerSection = {
    padding: 0,
    margin: 0
}

export const detailsWrapper = {
    marginRight: [pxToRem(0), pxToRem(0), pxToRem(33), pxToRem(33)]
}

export const imageWrapper = {
    width: [pxToRem(97), pxToRem(97), pxToRem(163), pxToRem(163)],
    height: [pxToRem(97), pxToRem(97), pxToRem(163), pxToRem(163)]
}

export const productTitle = {
    ...commonStyle,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    paddingTop: [pxToRem(5), pxToRem(5), pxToRem(22), pxToRem(22)],
    margin: 0,
    textTransform: 'none'
}

export const variationBox = {
    paddingTop: [pxToRem(10), pxToRem(10), pxToRem(20), pxToRem(20)],
    paddingBottom: [pxToRem(5), pxToRem(5), pxToRem(20), pxToRem(20)]
}

export const variationItem = {
    ...commonStyle,
    margin: 0,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    color: 'cav_light_input_gray'
}

export const buttonsSection = {
    width: '43%',
    paddingTop: pxToRem(10),
    paddingBottom: pxToRem(10),
    paddingLeft: pxToRem(35),
    paddingRight: pxToRem(50)
}

export const carSubTotal = {
    ...commonStyle,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: '500',
    margin: 0
}

export const carSubTotalValue = {
    ...carSubTotal,
    fontWeight: '400'
}

export const viewCartButton = {
    ...carSubTotal,
    height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
    width: [pxToRem(260), pxToRem(260), pxToRem(295), pxToRem(295)],
    paddingTop: [pxToRem(12)],
    paddingBottom: [pxToRem(12)],
    paddingLeft: [pxToRem(20)],
    paddingRight: [pxToRem(20)],
    marginTop: pxToRem(20),
    marginBottom: [pxToRem(10), pxToRem(10), pxToRem(10), pxToRem(15)],
    borderRadius: 0,
    color: 'cav_red',
    borderColor: 'cav_red',
    textAlign: 'center',
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: [pxToRem(1.5), pxToRem(1.5), pxToRem(1.68), pxToRem(1.68)],
    textTransform: 'uppercase',
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'none',
        backgroundColor: 'cav_red',
        color: 'white'
    }
}

export const checkoutButton = {
    ...viewCartButton,
    backgroundColor: 'cav_red',
    color: 'white',
    marginTop: 0,
    marginBottom: [pxToRem(0), pxToRem(0), pxToRem(0), pxToRem(10)],
    '&:hover': {
        textDecoration: 'none',
        backgroundColor: 'white',
        color: 'cav_red',
        borderWidth: pxToRem(1),
        borderColor: 'cav_red'
    }
}

export const footerButtonContainer = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
}

export const recommendWrapper = {
    paddingTop: [pxToRem(30), pxToRem(30), pxToRem(30), pxToRem(50)]
}

export const footerSection = {
    boxShadow: '0px -2px 4px 0px rgba(0, 0, 0, 0.10);rgba(255, 255, 255, 1)',
    padding: `${pxToRem(15)} ${pxToRem(11)}`,
    textAlign: 'center'
}

export const footerSubCartText = {
    ...carSubTotal
}
